import CrossSmallPath from "@ingka/ssr-icon/paths/cross-small";

export default CrossSmallPath;
